//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tabTree: {
      type: Array,
      required: true
    },
    tabData: {
      type: Object,
      required: true
    },
    listD: {
      type: Array,
      required: true
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    tabSubIndex: {
      type: Number,
      default: 0
    },
    pageNo: {
      type: Number,
      default: 0,
    },
    classId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      imgNull: require("@/assets/image/icon/icon_null.png"),
      iconAuthor: require("@/assets/image/icon/icon_author.png"),
      iconSound: require("@/assets/image/icon/icon_sound.png"),
      loading: false,
      finished: false,
      code: this.tabTree[this.tabIndex].code,
      currPage: this.pageNo,
      targetL: {
        //跳轉地址配置
        column: {
          path: "detail",
          params: [{ name: "id", label: "id"}] //跳轉所需參數
        },
        video: {
          path: "videoDetail",
          params: [{ name: "id", label: "id"}]
        },
        audio: {
          path: "audioDetail",
          params: [{ name: "id", label: "id"}]
        },
        ebook: {
          path: "ebookDetail",
          params: [{ name: "id", label: "id"}]
        }
      },
    };
  },
  methods: {
    onLoad() {
      let that = this
      setTimeout(() => {
        that.loading = false;

        if(this.listD.length == this.tabData.total){
          this.finished = true;
          return;
        }

        that.currPage = that.currPage + 1;

        let id = that.tabData.parentIds + "/" + that.tabData.classId;
        let postD = {
          pageSize: 24,
          pageNo: that.currPage,
          code: that.code,
          cmsClassIds: id
        };

        //console.log('this.tabTree',postD, this.tabTree);
        //this.$toast.loading();
        that.GLOBAL_.ccRequest.doSessionAxios(that.CONFIG.COLUMN.CLASSSEARCH, postD, "POST", "no login") //正式
          .then(res => {
            //console.log('res', res ,this.tabData.list.length);
            //this.$toast.close();
            // 加载状态结束
            this.loading = false;

            // 数据全部加载完成
            if (res.rows.length == 0 || this.listD.length >= res.total) {
              this.finished = true;
            }

            //console.log(this.currPage, this.tabIndex, this.tabSubIndex, this.finished)
            this.$emit('reChange', res.rows, this.currPage, this.tabIndex, this.tabSubIndex, this.finished);
          })
          .catch(err => {
            this.$toast.close();
            // console.log(err, "错误");
            console.log(err);
            if (err.response.data.code != 401) {
              this.$toast.text(err.response.data.message);
            }
          });


      }, 500);
    },
    gotoTarget(item,ind) {
      //let item = this.list[ind];
      //console.log('item',item);
      let types = item.mediaType; //类型
      let target = this.targetL[types];
      if (target == undefined) {
        //未配置的目標地址
        // console.log("error", "未配置的目標地址");
        return;
      }
      let pArr = target.params;
      let q = {};
      let obj = {};
      obj["path"] = target.path;
      console.log('pArr',pArr);
      pArr.forEach(p => {
        let val = item[p.name];
        //如果有傳入LABLE則，使用LABEL作為屬性值，沒有則使用name作為參數值
        let key = p.label ? p.label : p.name;
        q[key] = val;
      });

      obj["query"] = q;
      console.log(obj, q);
      //跳轉音頻詳情頁需要提前判斷是否登錄
      //this.$router.replace(obj)
      this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
    }
  },
  created() {}
};



// WEBPACK FOOTER //
// ./src/components/list.vue